<div id="breadcrumb" class="division">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class=" breadcrumb-holder">

                    <!-- Breadcrumb Nav -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="demo-1.html">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">About Us</li>
                        </ol>
                    </nav>

                    <!-- Title -->
                    <h4 class="h4-sm steelblue-color">About Us</h4>

                </div>
            </div>
        </div> <!-- End row -->
    </div> <!-- End container -->
</div>

<section id="info-4" class="wide-100 info-section division">
    <div class="container">


        <!-- TOP ROW -->
        <div class="top-row">
            <div class="row d-flex align-items-center">


                <!-- INFO IMAGE -->
                <div class="col-lg-6">
                    <div class="info-4-img text-center wow fadeInUp" data-wow-delay="0.6s"
                        style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                        <img class="img-fluid" src="assets/images/dr Waheed sb.jpg" alt="info-image">
                    </div>
                </div>


                <!-- INFO TEXT -->
                <div class="col-lg-6">
                    <div class="txt-block pc-30 wow fadeInUp" data-wow-delay="0.4s"
                        style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

                        <!-- Section ID -->
                        <span class="section-id blue-color">Welcome to Movement Clinic</span>

                        <!-- Title -->
                        <h3 class="h3-md steelblue-color">Clinic with Innovative Approach to Treatment</h3>

                        <!-- Text -->
                        <p>Our clinic uses advanced techniques and smart technology to deliver better, faster care.
                           We focus on personalized treatment plans tailored to each patient’s unique needs
                        </p>

                        <!-- Text -->
                        <p>At our clinic, innovation meets compassion. We use the latest medical tools and evidence-based
                             methods to diagnose and treat effectively. Our team is committed to offering personalized care 
                             with faster recovery and better outcomes.
                             Experience healthcare that’s modern, efficient, and truly patient-focused
                        </p>

                        <!-- Singnature -->
                        <div class="singnature mt-35">

                            <!-- Text -->
                            <p class="p-small mb-15">Dr Waheed Ahmad, Head of Clinic</p>

                            <!-- Singnature Image -->
                            <!-- Recommended sizes for Retina Ready displays is 400x68px; -->
                            <img class="img-fluid" src="assets/images/signature-creator.png" width="200" height="34"
                                alt="signature-image">

                        </div>

                    </div>
                </div> <!-- END TEXT BLOCK -->


            </div> <!-- End row -->
        </div> <!-- END TOP ROW -->


    </div> <!-- End container -->
</section>

<section id="services-1" class="wide-50 services-section division bg-lightgrey">
    <div class="container">
        <div class="row">


            <!-- SERVICE BOX #1 -->
            <div class="col-sm-6 col-lg-3">
                <div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.4s"
                    style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

                    <!-- Icon -->
                    <span class="flaticon-137-doctor blue-color"></span>

                    <!-- Title -->
                    <h5 class="h5-sm steelblue-color">Qualified Doctors</h5>

                    <!-- Text -->
                    <p>Our team of highly qualified doctors is dedicated to providing expert, personalized care
                    </p>

                </div>
            </div>


            <!-- SERVICE BOX #2 -->
            <div class="col-sm-6 col-lg-3">
                <div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.6s"
                    style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">

                    <!-- Icon -->
                    <span class="flaticon-076-microscope blue-color"></span>

                    <!-- Title -->
                    <h5 class="h5-sm steelblue-color">Modern Equipment</h5>

                    <!-- Text -->
                    <p>We use modern, high-tech equipment to deliver safe, fast, and accurate medical care
                    </p>

                </div>
            </div>


            <!-- SERVICE BOX #3 -->
            <div class="col-sm-6 col-lg-3">
                <div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.8s"
                    style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">

                    <!-- Icon -->
                    <span class="flaticon-008-ambulance-6 blue-color"></span>

                    <!-- Title -->
                    <h5 class="h5-sm steelblue-color">Emergency Help</h5>

                    <!-- Text -->
                    <p>Our emergency services are available 24/7 to provide immediate and reliable medical care when you need it most
                    </p>

                </div>
            </div>


            <!-- SERVICE BOX #4 -->
            <div class="col-sm-6 col-lg-3">
                <div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="1s"
                    style="visibility: visible; animation-delay: 1s; animation-name: fadeInUp;">

                    <!-- Icon -->
                    <span class="flaticon-083-stethoscope blue-color"></span>

                    <!-- Title -->
                    <h5 class="h5-sm steelblue-color">Individual Approach</h5>

                    <!-- Text -->
                    <p>We provide personalized care tailored to each patient’s unique needs for better outcomes and comfort
                    </p>

                </div>
            </div>


        </div> <!-- End row -->
    </div> <!-- End container -->
</section>